import React, { useState, useEffect } from "react"
import Footer from "../components/footer"
import { createGlobalStyle } from "styled-components"
import { Form, Input, Modal, Select, Button } from "antd"
import { useCookies } from "react-cookie"
import { BaseUrl } from "../utils/config"
import axios from "axios"
import swal from "sweetalert"
import { createBrowserHistory, History } from "history"
import { Link, useHistory, useLocation } from "react-router-dom"
import { useNavigate } from "@reach/router"

const GlobalStyles = createGlobalStyle`
  header#myHeader.navbar.white {
    background: #212428;
  }
`
// tftx test test

const ForgotPassword = () => {
  const history = createBrowserHistory()
  const [isEmail, setIsEmail] = useState(false)
  const navigate = useNavigate()

  useEffect(async () => {}, [])

  const onFinish = values => {
    const Fobj = {
      email: values.email
    }

    if (!isEmail) {
      swal({
        // title: "Success!",
        text: "Please enter the Credentials",
        icon: "warning"
      })
    } else {
      axios
        .post(`${BaseUrl}/forgotpassword`, Fobj)
        .then(response => {
          if (response.data.status) {
            swal({
              title: "Success!",
              text: " We have emailed your password reset link!",
              icon: "success"
            })
          } else {
            swal({
              title: "Invalid/Unregistered Email",
              text: "User does not exist.",
              icon: "error"
            })
            // message.error(`password changed  failed`);
          }
        })
        .catch(error => {
          if (error?.response?.status === 500) {
            swal({
              title: "Server Error",
              text: error.response.data.message,
              icon: "error"
            })
          } else if (error?.response?.status === 429) {
            swal({
              title: "Error!",
              text: error.response.data.message,
              icon: "error"
            })
          }
        })
    }
  }
  const toLogin = () => {
    navigate("/login")
  }

  const toSignup = () => {
    navigate("/verifyEmail")
  }
  const toforgot = () => {
    navigate("/forgotPassword")
  }
  return (
    <div>
      {/* <GlobalStyles/> */}

      <section className="jumbotron breadcumb no-bg">
        <div className="mainbreadcumb">
          <div className="container">
            <div className="row align-items-center px-0">
              <div className="col-lg-4 offset-lg-4 m-auto px-0">
                <div className="box-login">
                  <Form
                    name="contactForm"
                    id="contact_form"
                    action=""
                    autoComplete="off"
                    name="control-hooks"
                    onFinish={onFinish}>
                    <h3>Forgot Password</h3>

                    <div className="field-set">
                      <label for="email">Email</label>
                      <Form.Item
                        name="email"
                        rules={[
                          {
                            type: "email",
                            message: "The input is not valid Email!"
                          },
                          {
                            required: true,
                            message: "Email is required."
                          }
                        ]}>
                        <Input
                          id="email"
                          className="form-control"
                          placeholder="Enter email"
                          onChange={e => {
                            setIsEmail(e.target.value)
                          }}
                        />
                      </Form.Item>
                    </div>

                    <div id="submit">
                      <input
                        type="submit"
                        id="send_message"
                        disabled={isEmail ? false : true}
                        value="Send password reset link"
                        className="btn btn-main color-2 mt-3"
                      />
                      <div className="clearfix"></div>

                      <input
                        type="button"
                        onClick={toLogin}
                        id="send_message"
                        value="Go back"
                        className="btn btn-main color-2 mt-3"
                      />
                      <div className="clearfix"></div>

                      <div className="spacer-single"></div>
                    </div>
                    {/* <div className="submit-buttons">
             <a className='colorPurple'> Signin</a>
            </div> */}
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <Footer /> */}
    </div>
  )
}
export default ForgotPassword
